import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Button as Btn } from 'components';
import { Image, Dropdown, Popup, Grid } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './ExamTemplateList.css';
const cx = classNames.bind(styles);

class PhishingTemplateFilter extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { handleInitFilter, filterClose, cancleCheck, executeFilter, paramData, filters, tempFilter, popupOpen, handlePopup } = this.props;

    // 구분 필터
    const isBasic = [
      { 1: defineMessages(formatMessage({ id: 'ExamTemplateList_2', defaultMessage: '기 본' })) },
      { 0: defineMessages(formatMessage({ id: 'ExamTemplateList_3', defaultMessage: '사용자' })) }
    ];

    const serviceTemplateFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'ExamTemplateList_1', defaultMessage: '구분' }))}
        />
        {isBasic.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.isBasicFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['isBasicArray'] &&
                      tempFilter['isBasicArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    // 피싱 단계 필터
    const phishingLevel = [
      { 1: 1 + defineMessages(formatMessage({ id: 'PhishingTemplateList_13', defaultMessage: '단계' })) },
      { 2: 2 + defineMessages(formatMessage({ id: 'PhishingTemplateList_13', defaultMessage: '단계' })) },
      { 3: 3 + defineMessages(formatMessage({ id: 'PhishingTemplateList_13', defaultMessage: '단계' })) }
    ];

    const phishingLevelFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'PhishingTemplateList_13', defaultMessage: '단계' }))}
        />
        {phishingLevel.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.phishingLevelFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['phishingLevelArray'] &&
                      tempFilter['phishingLevelArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    let isBasicArray =
      paramData.getIn(['filter', 'isBasicArray']) &&
      paramData.getIn(['filter', 'isBasicArray']).toJS();

    let phishingLevelArray =
      paramData.getIn(['filter', 'phishingLevelArray']) &&
      paramData.getIn(['filter', 'phishingLevelArray']).toJS();

    if (isBasicArray === undefined) {
      isBasicArray = [];
    }

    if (phishingLevelArray === undefined) {
      phishingLevelArray = [];
    }

    const totalArrayLength = isBasicArray.length + phishingLevelArray.length;

    let isBasicInfo = null;
    let phishingLevelInfo = null;

    if (isBasicArray.length > 0) {
      isBasicInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'ExamTemplateList_1', defaultMessage: '구분' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {isBasicArray.map((isBasic, index) => {
              const isBasicArray =
                paramData.getIn(['filter', 'isBasicArray']) &&
                paramData.getIn(['filter', 'isBasicArray']).toJS();

              let templateStatus = '';
              if (isBasicArray[index] === '0') {
                templateStatus = defineMessages(formatMessage({ id: 'ExamTemplateList_3', defaultMessage: '사용자' }));
              } else if (isBasicArray[index] === '1') {
                templateStatus = defineMessages(formatMessage({ id: 'ExamTemplateList_2', defaultMessage: '기 본' }));
              }

              const text =
                isBasicArray[isBasicArray.length - 1] !== isBasicArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }

    if (phishingLevelArray.length > 0) {
      phishingLevelInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'PhishingTemplateList_10', defaultMessage: '피싱 단계' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {phishingLevelArray.map((data, index) => {
              const phishingLevelArray =
                paramData.getIn(['filter', 'phishingLevelArray']) &&
                paramData.getIn(['filter', 'phishingLevelArray']).toJS();

              let templateStatus = '';
              templateStatus = phishingLevelArray[index] + defineMessages(formatMessage({ id: 'PhishingTemplateList_13', defaultMessage: '단계' }));
              const text =
                phishingLevelArray[phishingLevelArray.length - 1] !== phishingLevelArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }

    // 툴팁 정보
    const tooltipInfo = (
      <div className={cx('tooltip-wrapper')}>
        <div className={cx('arrow')} />
        {isBasicInfo}
        {phishingLevelInfo}
      </div>
    );

    return (
      <Tooltip
        classes={{
          tooltip: 'tooltip',
          tooltipOpen: totalArrayLength > 0 ? '' : 'close'
        }}
        title={tooltipInfo}
        placement="bottom">
        <div className={cx('target-dropdown-area', totalArrayLength > 0 ? 'target-dropdown-area-border' : '')}>
          <div className={cx('dropdown-arrow-area', 'table-filter-arrow')}>
            {totalArrayLength > 0 ? (
              <div className={cx('number-box')}>{totalArrayLength}</div>
            ) : (
                <Image className={cx('dropdown-image')} src="/img/table/selectbox_number_arrow.png" />
              )}
          </div>
          <Popup
            className={cx('filter-popup')}
            trigger={
              <div className={cx('default-text', totalArrayLength > 0 ? 'filter-length' : '')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_35', defaultMessage: '필터' }))}
              </div>
            }
            open={popupOpen}
            onOpen={() => handlePopup(true)}
            onClose={() => { filterClose(), handlePopup(false) }}
            on="click"
            flowing
            position="bottom center">
            <Grid centered divided columns={2}>
              <Grid.Column textAlign="left">{serviceTemplateFilterOptions}</Grid.Column>
              <Grid.Column textAlign="left">{phishingLevelFilterOptions}</Grid.Column>
            </Grid>
            <Grid className={cx('bottom-options')}>
              <Grid.Column>
                <div className={cx('all-check-off')} onClick={handleInitFilter}>
                  {defineMessages(formatMessage({ id: 'Target_32', defaultMessage: '모든 필터 해제' }))}
                </div>
                <div className={cx('inline-block')}>
                  <Btn className={cx('button-border', 'button')} onClick={() => { cancleCheck(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취 소' }))}
                  </Btn>
                  <Btn
                    className={cx('button-brand', 'button')}
                    // loading={editOnProgress}
                    // disabled={disableSave && (editInvalid || editOnProgress)}
                    onClick={() => { executeFilter(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_37', defaultMessage: '확 인' }))}
                  </Btn>
                </div>
              </Grid.Column>
            </Grid>
          </Popup>
        </div>
      </Tooltip>
    );
  }
}

export default injectIntl(PhishingTemplateFilter);



// WEBPACK FOOTER //
// ./src/script/components/examTemplate/PhishingTemplateFilter.js